import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { availability as availabilityPropTypes } from '../../../Availability/Availability.proptypes';
import ProductReplacedPartsTable from './ProductReplacedPartsTable';

const ProductReplacedParts = ({ children, replacementParts }) => {
  const [t] = useTranslation();
  return (
    <div className="mt-4">
      <h3 className="h4">{t('PDP_REPLACEMENT_PARTS')}</h3>
      <p className="text-md">{t('PDP_REPLACEMENT_PARTS_MSG')}</p>
      <ProductReplacedPartsTable replacementParts={replacementParts} />
      {children}
    </div>
  );
};

ProductReplacedParts.propTypes = {
  children: PropTypes.node,
  replacementParts: PropTypes.arrayOf(
    PropTypes.shape({
      availability: availabilityPropTypes,
      name: PropTypes.string,
      quantity: PropTypes.number,
      uniqueId: PropTypes.string
    }).isRequired
  )
};

export default ProductReplacedParts;
